<template>
  
  <div :id="_uid" class="ui small modal">
    <div class="ui header">
      Filtrar Títulos a Receber
    </div>
    <div class="content">
      <div class="ui form" :class="{ loading }">
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Emissão Inicial</label>
            <date-picker ref="startDatePicker" :autoInit="false" @onChange="onChangeStartDate" />
          </div>         
          <div class="eight wide field">
            <label class="form-label">Emissão Final</label>
            <date-picker ref="endDatePicker" :autoInit="false" @onChange="onChangeEndDate" />
          </div>                                          
        </div>  
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Vencimento Inicial</label>
            <date-picker ref="startDueDatePicker" :autoInit="false" @onChange="onChangeStartDueDate" />
          </div>         
          <div class="eight wide field">
            <label class="form-label">Vencimento Final</label>
            <date-picker ref="endDueDatePicker" :autoInit="false" @onChange="onChangeEndDueDate" />
          </div>   
        </div>    
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Status</label>
            <select-dropdown ref="statusDropdown" @onChange="onChangeStatus" />
          </div>
          <div class="eight wide field">
            <label class="form-label">Tipo</label>
            <select-dropdown ref="typeDropdown" @onChange="onChangeType" />
          </div>
        </div>      
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Clínica</label>
            <input v-model="filter.customerName">
          </div>          
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Sair
      </button>      
      <button v-if="showRemoveButton" class="ui teal basic button" @click="onRemove()">
        <i class="undo icon"></i> Remover
      </button>      
      <button class="ui blue button" @click="onApply()">
        <i class="checkmark icon"></i> Aplicar
      </button>
    </div>
  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import ReceivableService from "@/services/receivable-service"
  import modalDialog from "@/mixins/modal-dialog"
  import { DatePicker, SelectDropdown } from "@/components"

  export default {
    
    name: "ReceivablesFilterModal",

    mixins: [modalDialog],

    data() {
      return {
        filter: {},
        showRemoveButton: false,
      }
    },

    components: {
      DatePicker,
      SelectDropdown,
    },

    methods: {     
      
      onShow() {
        this.loading = true
        this.emitEvent = null
      },

      onVisible() {        
        
        this.initFilter()
        this.loadDatePickers()
        this.loadDropdowns()

        this.loading = false
      },

      setQuickFilter(option) {
        
        this.updateStore(null)
        this.initFilter()

        if (option == "expired") {
          
          this.filter.status = "expired"

        } else if (option == "expiring_today") {

          this.filter.startDueDate = new Date()
          this.filter.endDueDate = new Date()

        } else if (option == "expiring_this_week") {

          this.filter.startDueDate = moment.getFirstDayOfWeek()
          this.filter.endDueDate = moment.getLastDayOfWeek()
        }

        this.loadDatePickers()
        this.loadDropdowns()

        return this.onApply()
      },

      initFilter() {

        this.$refs.startDatePicker.clearDate()
        this.$refs.endDatePicker.clearDate()
        this.$refs.startDueDatePicker.clearDate()
        this.$refs.endDueDatePicker.clearDate()
        this.$refs.statusDropdown.reset()
        this.$refs.typeDropdown.reset()

        if (this.$store.state.pages.filters.receivables) {

          this.showRemoveButton = true
          this.filter = this.$cloneObject(this.$store.state.pages.filters.receivables)

        } else {          

          this.showRemoveButton = false
          this.filter = { 
            startDate: null, 
            endDate: null, 
            startDueDate: null, 
            endDueDate: null,
            status: "*", 
            type: "*",
            customer: "",
          }
        }   
        
        this.refreshData()
      },

      loadDatePickers() {
        
        this.$refs.startDatePicker.initCalendar({ force: true })
        this.$refs.endDatePicker.initCalendar({ force: true })
        this.$refs.startDueDatePicker.initCalendar({ force: true })
        this.$refs.endDueDatePicker.initCalendar({ force: true })
        
        if (this.filter.startDate)
          this.$refs.startDatePicker.setDate(this.filter.startDate)
        
        if (this.filter.endDate)
          this.$refs.endDatePicker.setDate(this.filter.endDate)
        
        if (this.filter.startDueDate)
          this.$refs.startDueDatePicker.setDate(this.filter.startDueDate)
        
        if (this.filter.endDueDate)
          this.$refs.endDueDatePicker.setDate(this.filter.endDueDate)
      },

      loadDropdowns() {        
        this.loadStatusDropdown()
        this.loadTypeDropdown()
      },   
      
      loadStatusDropdown() {

        let values = [{ id: "*", value: '<i class="asterisk icon"></i> Todos' }]
        const statusList = ReceivableService.getStatusList()
        
        for (let status of statusList) {
          values.push(status)
        }

        this.$refs.statusDropdown.setValues(values, this.filter.status)
      },

      loadTypeDropdown() {

        let values = [{ id: "*", value: '<i class="asterisk icon"></i> Todos' }]
        const typeList = ReceivableService.getTypeList()
        
        for (let type of typeList) {
          values.push(type)
        }

        this.$refs.typeDropdown.setValues(values, this.filter.type)
      },

      onChangeStartDate(date) {
        this.filter.startDate = date
        this.refreshData()
      },

      onChangeEndDate(date) {
        this.filter.endDate = date
        this.refreshData()          
      },

      onChangeStartDueDate(date) {
        this.filter.startDueDate = date
        this.refreshData()          
      },

      onChangeEndDueDate(date) {
        this.filter.endDueDate = date
        this.refreshData()          
      },

      onChangeStatus(status) {
        this.filter.status = status
        this.refreshData()
      },

      onChangeType(type) {
        this.filter.type = type
        this.refreshData()
      },

      refreshData() {
        this.filter = this.$cloneObject(this.filter)
      },

      onApply() {

        this.updateStore(this.filter)

        let data = this.$cloneObject(this.filter)

        if (data.startDate)
          data.startDate = moment(data.startDate).format("YYYY-MM-DD")

        if (data.endDate)  
          data.endDate = moment(data.endDate).format("YYYY-MM-DD")

        if (data.startDueDate)  
          data.startDueDate = moment(data.startDueDate).format("YYYY-MM-DD")

        if (data.endDueDate)  
          data.endDueDate = moment(data.endDueDate).format("YYYY-MM-DD")
        
        this.emitEvent = { event: "onApply", data }

        this.hide()
        
        return data
      },

      updateStore(filter) {

        let filters = this.$cloneObject(this.$store.state.pages.filters)

        filters.receivables = filter ? this.$cloneObject(filter) : null

        this.$store.commit("pages/setFilters", filters)
      },

      onRemove() {

        this.clear()

        this.emitEvent = { event: "onRemove" }

        this.hide()      
      },

      clear() {
        this.updateStore(null)
      },
    },
  }

</script>